import React, { Component } from "react";
import { apiReadOneAsset } from "../../../../utils/apis.js"
import Dialog from "../../../dialogs/dialog.js";
import EditListSt from "../subtitles/list-st/edit-list-st.js";
import { configurations_getDefaultParams } from "../../../../utils/configurations.js";
import { V2_ConvertSecondToTimeCodeStringFromAsset, V2_getIntervalStringFromAsset } from "../../../../utils/timecodev2.js";
import "./assetsmanager.css"



class DisplaySubtitle extends Dialog
{
  constructor(props) 
  {
    super(props);

    const title = {
        en:"Sous-titres", 
        fr:"Subtitles",
      };
    this.state.title = title;

    this.state.buttons = 
    [
      {type:"back", disabled:false},
      
    ]

    this.handleButton =  this.handleButton.bind(this);
    this.apicallback = this.apicallback.bind(this)

    this.onQuit = this.onQuit.bind(this)
    this.editListeStRef = React.createRef();

    this.getTimeCodeString = this.getTimeCodeString.bind(this)
    this.getIntervalString = this.getIntervalString.bind(this)

    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.subtitlemove = this.subtitlemove.bind(this);
    
    this.state.stparams = configurations_getDefaultParams();

    this.displayParameters = {
      fontName: 'Arial', // « nom de la police à utiliser »
      borderWidth: '5px', // épaisseur de la bordure autour du caractère
      borderColor: 'black', // « black »
      marginLeft: '5%',
      marginRight: '5%',
      marginTop: '5%',
      marginBottom: '5%',
      displayNumberOfLines: 23, // 10….50
    };


  }


componentDidMount()
{
    super.componentDidMount()
    var datas = {asid: this.props.asset.asid};
    
    apiReadOneAsset (datas, this.apicallback)

    window.addEventListener('keydown', this.handleKeyDown);
}

componentWillUnmount()
{
    window.removeEventListener('keydown', this.handleKeyDown);
}

componentDidUpdate()
{
  console.log("component did update ", this.state.title.fr)
}

    // *********************************************************************************************************************
    // formatage time code
    // *********************************************************************************************************************
    getTimeCodeString(time) {
      return V2_ConvertSecondToTimeCodeStringFromAsset(time, this.props.asset);
    } 
  
    getIntervalString(timebefore, time)
    {
      return V2_getIntervalStringFromAsset(timebefore, time, this.props.asset, false);
    }



handleKeyDown = (event) =>
    {

    }

subtitlemove(id, timeCode) {
 
    if (this.editListeStRef && this.editListeStRef.current) {

      this.editListeStRef.current.setCurrentSubtitle(
        id,
        false
      );
    }

  }



 apicallback(datas)
 {
    
    if (datas.ret)
    {
          var asdatas = JSON.parse(datas.asdatas);
          var subtitles = asdatas.subtitles;
          var params = asdatas.params;
          subtitles.forEach((subtitle, index) => {
              subtitle.id = index;
            });
      
          if ((this.editListeStRef) && (this.editListeStRef.current))
          {

          
              this.editListeStRef.current.setSubtitles(
                this.props.asset.asid,
                params,
                subtitles
              );
          }

          this.setState({stparams: params});
    }
    
 }
  onQuit()
  {
    this.props.onButton("back");    
  }


  handleButton(buttonkey)
  {
    console.log("on click", buttonkey)
    if (buttonkey === "back")
        this.props.onButton("back");
    
  }

  
  render()
  {
    var maxwidth =  (window.innerWidth * 35)/100;
    if (maxwidth > 800) maxwidth = 800;

    var maxheight =  (window.innerHeight * 75)/100;
    if (maxheight > 500) maxheight = 500;


    var retour = [<></>];
    if (this.props.display)
    {

        retour =
        (
          <div style = {{width:maxwidth, height: maxheight}}>
            
                    <EditListSt
                    ref={this.editListeStRef}
                    Zindex={0}
                    readonly={true}
                    subtitleParameters={this.state.stparams}
                    displayParameters = {this.displayParameters}
                    getTimeCodeString={this.getTimeCodeString}
                    getIntervalString = {this.getIntervalString}

                    onMove={this.subtitlemove}
                    />
                            

          </div>
        )
      }
    return super.render(retour);
  }


}


export default DisplaySubtitle;